import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';

const Home = () => {
  const { isDarkMode } = useTheme();

  return (
    <>
      <style>
        {`
          @keyframes pulse {
            0% {
              box-shadow: 0 0 0 0 rgba(139, 92, 246, 0.8);
            }
            100% {
              box-shadow: 0 0 0 20px rgba(139, 92, 246, 0);
            }
          }
          
          @keyframes float {
            0%, 100% {
              transform: translateY(0px);
            }
            50% {
              transform: translateY(-80px);
            }
          }
          
          @keyframes logoGlow {
            0%, 100% {
              filter: drop-shadow(0 0 5px rgba(139, 92, 246, 0.5));
            }
            50% {
              filter: drop-shadow(0 0 15px rgba(139, 92, 246, 0.8)) drop-shadow(0 0 25px rgba(139, 92, 246, 0.4));
            }
          }
          
          @keyframes logoColorShift {
            0% {
              filter: hue-rotate(0deg) drop-shadow(0 0 5px rgba(139, 92, 246, 0.5));
            }
            25% {
              filter: hue-rotate(90deg) drop-shadow(0 0 8px rgba(139, 92, 246, 0.6));
            }
            50% {
              filter: hue-rotate(180deg) drop-shadow(0 0 15px rgba(139, 92, 246, 0.8));
            }
            75% {
              filter: hue-rotate(270deg) drop-shadow(0 0 8px rgba(139, 92, 246, 0.6));
            }
            100% {
              filter: hue-rotate(360deg) drop-shadow(0 0 5px rgba(139, 92, 246, 0.5));
            }
          }
          
          @media (max-width: 1024px) {
            .hero-section {
              padding-top: clamp(1rem, 3vw, 2rem) !important;
            }
          }
          
        `}
      </style>
      <div className="dashboard-page home-page" style={{ 
        background: isDarkMode ? 'linear-gradient(135deg, #282440 0%, #1a1a2e 100%)' : 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        color: isDarkMode ? 'white' : '#1e293b',
        marginTop: '0',
        minHeight: '100vh',
        position: 'relative',
        zIndex: 1,
        top: '0',
        left: '0',
        right: '0',
        width: '100%'
      }}>
      <div className="container">
        {/* Hero Section */}
        <div className="hero-section" style={{ 
          textAlign: 'center', 
          marginBottom: 'clamp(2rem, 8vw, 6rem)',
          padding: 'clamp(4rem, 8vw, 6rem) clamp(1rem, 4vw, 0) clamp(2rem, 6vw, 4rem)'
        }}>
          {/* Icon */}
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            marginBottom: 'clamp(1rem, 4vw, 2rem)' 
          }}>
            <div style={{
              width: 'clamp(100px, 15vw, 150px)',
              height: 'clamp(100px, 15vw, 150px)',
              borderRadius: '50%',
              backgroundColor: 'transparent',
              border: `clamp(2px, 0.5vw, 3px) solid ${isDarkMode ? '#8B5CF6' : '#8B5CF6'}`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '0px',
              overflow: 'visible',
              position: 'relative',
              animation: 'pulse 2s ease-in-out infinite, float 18s ease-in-out infinite',
              transition: 'all 0.3s ease'
            }}>
              <img 
                src={isDarkMode ? "/images/AI-MCP-Bio_Logo_3_White.svg" : "/images/AI-MCP-Bio_Logo_3_Black.svg"} 
                alt="AI-MCP-Bio Logo" 
                style={{
                  width: '95%',
                  height: '95%',
                  objectFit: 'contain',
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                }}
              />
            </div>
          </div>

          {/* Main Heading */}
          <h1 style={{ 
            fontSize: 'clamp(2rem, 6vw, 4.5rem)', 
            fontWeight: 'bold', 
            marginBottom: 'clamp(1rem, 3vw, 2rem)',
            color: '#9D4EDD',
            lineHeight: '1.2',
            maxWidth: '800px',
            margin: '0 auto clamp(1rem, 3vw, 2rem) auto',
            padding: '0 clamp(1rem, 4vw, 0)'
          }}>
            Connect Your AI to Bioinformatics Tools
          </h1>

          {/* Description */}
          <p style={{ 
            fontSize: 'clamp(1rem, 2.5vw, 1.3rem)', 
            color: isDarkMode ? '#B0B0B0' : '#475569',
            maxWidth: '600px',
            margin: '0 auto clamp(2rem, 5vw, 3rem) auto',
            lineHeight: '1.6',
            padding: '0 clamp(1rem, 4vw, 0)'
          }}>
            The fastest way to let your AI assistant interact with specialized bioinformatics tools, 
            databases, and computational workflows through a standardized interface.
          </p>

          {/* Call to Action Buttons */}
          <div style={{ 
            display: 'flex', 
            gap: 'clamp(1rem, 3vw, 1.5rem)', 
            justifyContent: 'center', 
            flexWrap: 'wrap',
            marginTop: 'clamp(1rem, 3vw, 2rem)',
            padding: '0 clamp(1rem, 4vw, 0)'
          }}>
            <Link 
              to="/mcp-servers" 
              style={{
                backgroundColor: '#8B5CF6',
                color: 'white',
                padding: 'clamp(0.875rem, 2vw, 1rem) clamp(1.5rem, 5vw, 2.5rem)',
                borderRadius: '8px',
                textDecoration: 'none',
                fontWeight: '600',
                fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
                transition: 'all 0.3s ease',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem',
                boxShadow: '0 4px 15px rgba(139, 92, 246, 0.3)',
                minHeight: '44px',
                minWidth: '120px'
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 6px 20px rgba(139, 92, 246, 0.4)';
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 15px rgba(139, 92, 246, 0.3)';
              }}
            >
              Get Started →
            </Link>
            <Link 
              to="/learn-more" 
              style={{
                backgroundColor: 'transparent',
                color: isDarkMode ? 'white' : '#8B5CF6',
                padding: 'clamp(0.875rem, 2vw, 1rem) clamp(1.5rem, 5vw, 2.5rem)',
                borderRadius: '8px',
                textDecoration: 'none',
                fontWeight: '600',
                fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
                transition: 'all 0.3s ease',
                border: `2px solid ${isDarkMode ? 'white' : '#8B5CF6'}`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem',
                minHeight: '44px',
                minWidth: '120px'
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(139, 92, 246, 0.1)';
                e.target.style.transform = 'translateY(-2px)';
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              Learn More
            </Link>
          </div>
        </div>

        {/* Bottom Call to Action Section */}
        <div style={{
          backgroundColor: isDarkMode ? 'rgba(139, 92, 246, 0.05)' : 'rgba(139, 92, 246, 0.05)',
          border: `2px solid ${isDarkMode ? 'rgba(139, 92, 246, 0.2)' : 'rgba(139, 92, 246, 0.2)'}`,
          borderRadius: '20px',
          padding: 'clamp(2rem, 6vw, 4rem) clamp(1rem, 4vw, 2rem)',
          textAlign: 'center',
          marginTop: 'clamp(2rem, 6vw, 4rem)'
        }}>
          <h2 style={{ 
            fontSize: 'clamp(1.5rem, 5vw, 2.5rem)', 
            fontWeight: 'bold', 
            marginBottom: 'clamp(1rem, 3vw, 1.5rem)',
            color: isDarkMode ? 'white' : '#1e293b',
            textShadow: isDarkMode ? '1px 1px 2px rgba(0,0,0,0.3)' : 'none',
            padding: '0 clamp(0.5rem, 2vw, 0)'
          }}>
            Ready to Transform Your Research?
          </h2>
          <p style={{ 
            fontSize: 'clamp(1rem, 2.5vw, 1.3rem)', 
            marginBottom: 'clamp(1.5rem, 4vw, 2.5rem)', 
            color: isDarkMode ? '#B0B0B0' : '#475569',
            maxWidth: '600px',
            margin: '0 auto clamp(1.5rem, 4vw, 2.5rem) auto',
            lineHeight: '1.6',
            padding: '0 clamp(0.5rem, 2vw, 0)'
          }}>
            Join the next generation of scientific computing. Experience the power of AI-driven bioinformatics today.
          </p>
          <Link 
            to="/mcp-servers" 
            style={{
              backgroundColor: '#8B5CF6',
              color: 'white',
              padding: 'clamp(1rem, 2.5vw, 1.2rem) clamp(1.5rem, 6vw, 3rem)',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '600',
              fontSize: 'clamp(1rem, 2.5vw, 1.3rem)',
              transition: 'all 0.3s ease',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5rem',
              boxShadow: '0 4px 15px rgba(139, 92, 246, 0.3)',
              minHeight: '44px',
              minWidth: '140px'
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 6px 20px rgba(139, 92, 246, 0.4)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 15px rgba(139, 92, 246, 0.3)';
            }}
          >
            Get Started →
          </Link>
        </div>

        {/* Features Preview Section */}
        <div style={{ marginTop: 'clamp(2rem, 8vw, 6rem)', marginBottom: 'clamp(2rem, 6vw, 4rem)' }}>
          <h2 style={{
            fontSize: 'clamp(1.5rem, 5vw, 2.5rem)',
            fontWeight: 'bold',
            marginBottom: 'clamp(1.5rem, 5vw, 3rem)',
            color: isDarkMode ? '#8B5CF6' : '#8B5CF6',
            textAlign: 'center',
            borderBottom: `3px solid ${isDarkMode ? '#8B5CF6' : '#8B5CF6'}`,
            paddingBottom: '0.5rem',
            padding: '0 clamp(0.5rem, 2vw, 0)'
          }}>
            Why Choose AI-MCP-Bio?
          </h2>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 300px), 1fr))', gap: 'clamp(1rem, 3vw, 2rem)' }}>
            <div style={{
              backgroundColor: isDarkMode ? 'rgba(139, 92, 246, 0.05)' : 'rgba(139, 92, 246, 0.05)',
              padding: 'clamp(1.5rem, 4vw, 2rem)',
              borderRadius: '12px',
              border: `1px solid ${isDarkMode ? 'rgba(139, 92, 246, 0.2)' : 'rgba(139, 92, 246, 0.2)'}`,
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              textAlign: 'center'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = isDarkMode ? '0 10px 25px rgba(139, 92, 246, 0.2)' : '0 10px 25px rgba(139, 92, 246, 0.2)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}>
              <div style={{ fontSize: 'clamp(2rem, 5vw, 2.5rem)', marginBottom: 'clamp(0.75rem, 2vw, 1rem)' }}>🔬</div>
              <h3 style={{ fontSize: 'clamp(1.1rem, 3vw, 1.4rem)', fontWeight: 'bold', marginBottom: 'clamp(0.75rem, 2vw, 1rem)', color: '#8B5CF6' }}>
                Specialized MCP Servers
              </h3>
              <p style={{ fontSize: 'clamp(0.9rem, 2vw, 1rem)', lineHeight: '1.6', color: isDarkMode ? '#D1D5DB' : '#666' }}>
                Access curated bioinformatics tools through standardized Model Context Protocol servers
              </p>
            </div>
            
            <div style={{
              backgroundColor: isDarkMode ? 'rgba(139, 92, 246, 0.05)' : 'rgba(139, 92, 246, 0.05)',
              padding: 'clamp(1.5rem, 4vw, 2rem)',
              borderRadius: '12px',
              border: `1px solid ${isDarkMode ? 'rgba(139, 92, 246, 0.2)' : 'rgba(139, 92, 246, 0.2)'}`,
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              textAlign: 'center'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = isDarkMode ? '0 10px 25px rgba(139, 92, 246, 0.2)' : '0 10px 25px rgba(139, 92, 246, 0.2)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}>
              <div style={{ fontSize: 'clamp(2rem, 5vw, 2.5rem)', marginBottom: 'clamp(0.75rem, 2vw, 1rem)' }}>⚡</div>
              <h3 style={{ fontSize: 'clamp(1.1rem, 3vw, 1.4rem)', fontWeight: 'bold', marginBottom: 'clamp(0.75rem, 2vw, 1rem)', color: '#8B5CF6' }}>
                Pre-configured Workflows
              </h3>
              <p style={{ fontSize: 'clamp(0.9rem, 2vw, 1rem)', lineHeight: '1.6', color: isDarkMode ? '#D1D5DB' : '#666' }}>
                Jump-start your research with ready-to-use bioinformatics pipelines
              </p>
            </div>
            
            <div style={{
              backgroundColor: isDarkMode ? 'rgba(139, 92, 246, 0.05)' : 'rgba(139, 92, 246, 0.05)',
              padding: 'clamp(1.5rem, 4vw, 2rem)',
              borderRadius: '12px',
              border: `1px solid ${isDarkMode ? 'rgba(139, 92, 246, 0.2)' : 'rgba(139, 92, 246, 0.2)'}`,
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              textAlign: 'center'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = isDarkMode ? '0 10px 25px rgba(139, 92, 246, 0.2)' : '0 10px 25px rgba(139, 92, 246, 0.2)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}>
              <div style={{ fontSize: 'clamp(2rem, 5vw, 2.5rem)', marginBottom: 'clamp(0.75rem, 2vw, 1rem)' }}>🤖</div>
              <h3 style={{ fontSize: 'clamp(1.1rem, 3vw, 1.4rem)', fontWeight: 'bold', marginBottom: 'clamp(0.75rem, 2vw, 1rem)', color: '#8B5CF6' }}>
                AI-Powered Integration
              </h3>
              <p style={{ fontSize: 'clamp(0.9rem, 2vw, 1rem)', lineHeight: '1.6', color: isDarkMode ? '#D1D5DB' : '#666' }}>
                Leverage AI to discover, connect, and optimize your research tools
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Home;
